/*
ALL RIGHTS RESERVED. The content of this document is protected by copyright and constitutes trade secrets.
The content hereof may also be protected by patents, trademarks, design rights and other intellectual property rights.
The rights contained herein are owned or licensed by Temperature Sensitive Solutions Systems Sweden AB,
reg. no. 556278-0816, Sweden, ("TSS"), and may not be used, licensed, assigned, transferred, reproduced, copied,
disclosed, disseminated, modified or amended in any way not expressly and specifically granted by TSS in writing.
TSS and TSS' suppliers reserves any and all rights not expressly granted to you in writing, including the right to take
any and all actions deemed appropriate to safeguard its rights in and to the content of this document.
*/
import 'typeface-roboto';
import 'babel-polyfill';
import 'normalize.css';
import React, { Component, Fragment } from 'react';
import { Switch, Route } from 'react-router-dom';
import { css, StyleSheet } from 'aphrodite';
import { HEADER_HEIGHT, ErrorPage } from 'tss-core-lib-components';
import Header from './pages/Header';
import HelpContainer from './containers/HelpContainer';
import { version } from '../package.json';

let styles;

class App extends Component {
  static propTypes = {};
  static defaultProps = {};

  render() {
    return (
      <Fragment>
        <div>
          <Header />
          <div className={ css( styles.innerContent ) }>
            <Switch>
              <Route
                render={ () => [
                  <div key="container">
                    <Switch>
                      <Route
                        path="/error/:code"
                        render={ ( { match } ) => <ErrorPage code={ match.params.code } /> }
                      />
                      <Route path="/" component={ HelpContainer } />
                    </Switch>
                  </div>,
                ] }
              />
            </Switch>
          </div>
          <div className={ css( styles.versionContainer ) }>{ version }</div>
        </div>
      </Fragment>
    );
  }
}

styles = StyleSheet.create( {
  innerContent: {
    marginTop: HEADER_HEIGHT,
    flex: '1 1 50%',
    position: 'relative',
  },
  versionContainer: {
    display: 'none',
    margin: 0,
    position: 'absolute',
    left: '50%',
  },
} );

export default App;



// WEBPACK FOOTER //
// ./src/App.js